import React from 'react';
import { Link } from 'react-router-dom';

const Changelog = () => {
  const versions = [
    {
      version: '1.1.4',
      date: '14. Oktober 2025',
      title: 'Erweiterte Auto-Break Overlay Transition',
      changes: [
        {
          type: 'improvement',
          title: 'Zweistufige Auto-Break Anzeige',
          description: 'Erste 30 Sekunden: Kleineres Overlay ohne Sponsoren (w-1/3, kleinere Schrift) für weniger aufdringliche Anzeige. Nach 30 Sekunden: Automatischer Übergang zum vollständigen Overlay mit Sponsor-Karussell.'
        },
        {
          type: 'improvement',
          title: 'Intelligente Overlay-Größenanpassung',
          description: 'Reduzierte Textgrößen (4vh Titel, 12vh Timer) in der ersten Phase für fokussierte Darstellung. Nahtloser Übergang zu Standard-Größen (8vh/20vh) nach 30 Sekunden.'
        },
        {
          type: 'improvement',
          title: 'Selektive Anwendung',
          description: 'Enhancement gilt nur für automatische Breaks (Auto-Break aktiviert). Manuelle Breaks zeigen weiterhin sofort das vollständige Overlay. Vollständige Rückwärtskompatibilität.'
        }
      ]
    },
    {
      version: '1.1.3',
      date: '1. Oktober 2025',
      title: 'Tab-Navigation in Settings & Beta Features',
      changes: [
        {
          type: 'feature',
          title: 'Tab-Navigation in Settings',
          description: 'Neue übersichtliche Tab-Struktur mit drei Bereichen: General Settings (Timer, Farben, Sound, Sponsoren), Media License (Entertainment Lizenz), Beta Features (experimentelle Funktionen)'
        },
        {
          type: 'feature',
          title: 'Beta Features Sektion',
          description: 'Neuer dedizierter Bereich für experimentelle Features. Alle Beta-Features sind standardmäßig deaktiviert und müssen manuell aktiviert werden. Klare Kennzeichnung als experimentell mit Beschreibungen.'
        },
        {
          type: 'feature',
          title: 'Sechstes Sponsorenbild',
          description: 'Erhöhung der Sponsor-Slots von 5 auf 6 Bilder. Alle Bilder rotieren automatisch im Carousel auf dem Scoreboard.'
        },
        {
          type: 'improvement',
          title: 'Reorganisierte Settings',
          description: 'Auto Break und Team Inferiority Display in Beta Features verschoben. Entertainment License in separaten Media License Tab. Logische Gruppierung aller Einstellungen.'
        },
        {
          type: 'improvement',
          title: 'Geänderte Standardwerte',
          description: 'Auto Break und Team Inferiority Display sind jetzt standardmäßig deaktiviert (vorher aktiviert). Benutzer müssen Beta-Features explizit in Settings → Beta Features aktivieren.'
        },
        {
          type: 'testing',
          title: 'Angepasste E2E-Tests',
          description: 'Tests navigieren jetzt zu den entsprechenden Settings-Tabs und aktivieren Beta-Features im beforeEach. Aktualisierte Selektoren für Tab-basierte Struktur.'
        }
      ]
    },
    {
      version: '1.1.2',
      date: '30. September 2025',
      title: 'Auto-Break Toggle & Break Selection Modal',
      changes: [
        {
          type: 'feature',
          title: 'Auto-Break Toggle',
          description: 'Neuer Toggle in den Settings um automatische Breaks bei Periodenwechseln ein-/auszuschalten. Standard: aktiviert für Rückwärtskompatibilität.'
        },
        {
          type: 'feature',
          title: 'Break Selection Modal',
          description: 'Neues Modal zur manuellen Break-Auswahl mit drei Buttons (P1→P2, P2→P3, P3→P4). Zeigt konfigurierte Dauern an und ermöglicht gezielte Break-Aktivierung.'
        },
        {
          type: 'improvement',
          title: 'Flexibles Break-System',
          description: 'Alle Periodenwechsel (inkl. P1→P2) respektieren jetzt den Auto-Break Toggle. Manuelle Breaks können unabhängig vom Toggle gestartet werden.'
        },
        {
          type: 'improvement',
          title: 'Optimierte Settings UI',
          description: 'Auto-Break Toggle im zweispaltigen Layout neben Break P3→P4 positioniert. Konsistentes Design mit Buzzer Toggle.'
        },
        {
          type: 'testing',
          title: 'Erweiterte E2E-Tests',
          description: 'Neue break-selection-modal.spec.js mit 8 Tests. Angepasste Tests für Auto-Break Toggle und verbesserte Checkbox-Selektion.'
        }
      ]
    },
    {
      version: '1.1.1',
      date: '29. September 2025',
      title: 'Konfigurierbare Break-Dauern & Unterzahlberechnung',
      changes: [
        {
          type: 'feature',
          title: 'Separate Break-Dauern für jeden Periodenwechsel',
          description: 'Drei individuell konfigurierbare Break-Dauern: P1→P2 (Standard: 10 Min), P2→P3 (Standard: 3 Min), P3→P4 (Standard: 2 Min)'
        },
        {
          type: 'feature',
          title: 'Automatische Break-Dauer-Auswahl',
          description: 'Das System wählt automatisch die richtige Break-Dauer basierend auf dem aktuellen Periodenwechsel'
        },
        {
          type: 'feature',
          title: 'Unterzahlzeit-Berechnung (Team Inferiority) für Zeitnehmende',
          description: 'Automatische Kumulierung der Strafzeiten: 1 Strafe = Strafzeit, ab 2 Strafen = Sequentielle Strafzeiten für das Team. Echtzeit-Countdown synchronisiert mit Spieltimer.'
        },
        {
          type: 'improvement',
          title: 'Verbesserte Settings UI',
          description: 'Zweispaltiges Layout für Break-Einstellungen und klarere Beschriftungen (Default Period, Overtime Period, Break P1→P2/P2→P3/P3→P4)'
        },
        {
          type: 'improvement',
          title: 'Enhanced Break System',
          description: 'Breaks werden jetzt für alle Periodenwechsel (P1→P2, P2→P3, P3→P4) automatisch gestartet wenn die Overtime-Logik einen Wechsel erlaubt'
        },
        {
          type: 'testing',
          title: 'Umfassende E2E-Tests',
          description: 'Neue Tests für alle Break-Übergänge mit automatischer Timer-Anpassung und Board-Reset für bessere Test-Isolation'
        }
      ]
    },
    {
      version: '1.1.0',
      date: '29. September 2025',
      title: 'Intelligente Teamfoul-Markierungen & Verbesserungen',
      changes: [
        {
          type: 'feature',
          title: 'Intelligente Teamfoul-Markierungen',
          description: 'Automatische Erkennung der Brand Color mit alternativer gelb/orange Markierung bei rötlichen Farben für bessere Sichtbarkeit'
        },
        {
          type: 'feature',
          title: 'Buzzer-Lautstärke Kontrolle',
          description: 'Einstellbare Buzzer-Lautstärke von 0-200% in den Settings mit localStorage-Persistierung'
        },
        {
          type: 'improvement',
          title: 'Konsistente LiveView',
          description: 'Teamfoul-Markierungen verwenden jetzt auch in der LiveView die intelligente Farblogik'
        },
        {
          type: 'testing',
          title: 'E2E-Tests erweitert',
          description: 'Umfassende Tests für Teamfoul-Funktionalität inklusive Warnung-Farben und Buzzer-Sounds'
        }
      ]
    },
    {
      version: '1.0.0',
      date: '22. September 2025',
      title: 'Erste stabile Version',
      changes: [
        {
          type: 'feature',
          title: 'Vollständiges Scoreboard System',
          description: 'Komplette Rink Hockey Scoreboard Funktionalität mit Timer, Scores, Teamfouls und Penalties'
        },
        {
          type: 'feature',
          title: 'LiveView Modus',
          description: 'Separate LiveView für Zuschauer mit optimierter Darstellung'
        },
        {
          type: 'feature',
          title: 'Entertainment System',
          description: 'PreGame Videos, In-Game Musik und Sponsor-Karussell'
        },
        {
          type: 'feature',
          title: 'Timeout Management',
          description: 'Vollständige Timeout-Verwaltung mit visuellen Overlays'
        },
        {
          type: 'feature',
          title: 'Personalisierung',
          description: 'Anpassbare Brand Colors und Sponsor-Bilder'
        },
        {
          type: 'feature',
          title: 'Buzzer System',
          description: 'Automatische Buzzer-Sounds bei Spielende und Teamfouls'
        }
      ]
    }
  ];

  const getTypeIcon = (type) => {
    switch (type) {
      case 'feature':
        return '🆕';
      case 'improvement':
        return '⚡';
      case 'bugfix':
        return '🐛';
      case 'testing':
        return '🧪';
      default:
        return '📝';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'feature':
        return 'bg-green-100 text-green-800';
      case 'improvement':
        return 'bg-blue-100 text-blue-800';
      case 'bugfix':
        return 'bg-red-100 text-red-800';
      case 'testing':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Changelog</h1>
              <p className="text-gray-600 mt-1">Alle Änderungen und Verbesserungen im Überblick</p>
            </div>
            <Link 
              to="/" 
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              ← Zurück zur Startseite
            </Link>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="space-y-8">
          {versions.map((version, index) => (
            <div key={version.version} className="bg-white rounded-lg shadow-md overflow-hidden">
              {/* Version Header */}
              <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold">Version {version.version}</h2>
                    <p className="text-blue-100 mt-1">{version.title}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-blue-100 text-sm">Veröffentlicht am</div>
                    <div className="text-white font-semibold">{version.date}</div>
                  </div>
                </div>
              </div>

              {/* Changes List */}
              <div className="p-6">
                <div className="space-y-4">
                  {version.changes.map((change, changeIndex) => (
                    <div key={changeIndex} className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg">
                      <div className="flex-shrink-0">
                        <span className="text-2xl">{getTypeIcon(change.type)}</span>
                      </div>
                      <div className="flex-grow">
                        <div className="flex items-center space-x-3 mb-2">
                          <h3 className="font-semibold text-gray-900">{change.title}</h3>
                          <span className={`px-2 py-1 text-xs font-medium rounded-full ${getTypeColor(change.type)}`}>
                            {change.type === 'feature' && 'Neue Funktion'}
                            {change.type === 'improvement' && 'Verbesserung'}
                            {change.type === 'bugfix' && 'Fehlerbehebung'}
                            {change.type === 'testing' && 'Tests'}
                          </span>
                        </div>
                        <p className="text-gray-600">{change.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 text-center">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Feedback & Vorschläge</h3>
            <p className="text-gray-600 mb-4">
              Haben Sie Ideen für neue Features oder haben einen Bug gefunden?
            </p>
            <div className="flex justify-center space-x-4">
              <Link 
                to="/manual" 
                className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors"
              >
                📖 Handbuch
              </Link>
              <Link 
                to="/videos" 
                className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors"
              >
                🎥 Video-Anleitungen
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Changelog;
